import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { ClientFormType } from "../enums";
import { ClientDataProps } from "../utils";
import { ClientLineDescription } from "./ClientLineDescription";
import styles from "./ClientsListView.module.scss";

interface Props {
  clientsData?: ClientDataProps[];
  className?: string;
}

export const ClientsListView = ({ clientsData, className }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={classNames(styles.clientsWrapper, className)}>
      {clientsData?.map((data) => {
        const clientLabel = data.clientFormTypes?.length
          ? data.clientFormTypes
              .map((type) =>
                type === ClientFormType.POLICY_HOLDER && data.clientPolicyHolderType
                  ? t("client.helpers." + data.clientPolicyHolderType + "PolicyHolder")
                  : t("client.enums.formType." + type),
              )
              .join(", ")
          : t("client.helpers.client");

        return (
          <div key={`${data.client.id}-${data.clientFormTypes.join(",")}`} className={styles.clientRow}>
            <span className={styles.clientLabel}>{clientLabel}</span>
            <ClientLineDescription client={data.client} />
          </div>
        );
      })}
    </div>
  );
};
